import { render, staticRenderFns } from "./CrudComponent.vue?vue&type=template&id=9617df24"
import script from "./CrudComponent.vue?vue&type=script&lang=js"
export * from "./CrudComponent.vue?vue&type=script&lang=js"
import style0 from "./CrudComponent.vue?vue&type=style&index=0&id=9617df24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports